import { COREBASEURL } from '../../constants/global';
import { locationType } from '../types';
import * as utils from './utils';

const returnValue = (query: string, value: any) => (value ? query + '' + value : '');

const checkReturned = (data: string) => (data ? '?' + data : '');

export const getZone = () =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'zone',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.zone,
	});

export const getGEOZone = () =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'GeographicalZone',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.geozone,
	});

export const getPoolingUnit = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				COREBASEURL +
				'PoolingUnit/paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.pollingUnit,
	});

export const getWard = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				COREBASEURL +
				'ward/paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.ward,
	});

// export const sendOtpAction = (data: { userName: string }) => {
//   return utils.httpPostMethod({
//     apiData: {
//       url: '',
//       customurl: 'https://core-erms.herokuapp.com/api/v1/Auth/SendOtp',
//       header: utils.header(),
//       data: JSON.stringify(data)
//     },
//     actionType: authType.sendOtp
//   })
// }

export const getWardsInLGA = (data: { lgaIds: number[] }) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'Ward/getWardsInLga',
			header: utils.header(),
			data: JSON.stringify(data),
		},
		actionType: locationType.wardsInLGA,
	});

export const getWardsInConsistuency = (id: number) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + `ConstituencyWard/getWardsInConstituency?Constituencyid=${id}`,
			header: utils.header(),
		},
		actionType: locationType.wardsInConsistuency,
	});

export const getPollingUnitsInWard = (data: { wardIds: number[] }) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'PoolingUnit/getPollingUnitsInWard',
			header: utils.header(),
			data: JSON.stringify(data),
		},
		actionType: locationType.pollingUnitsInWard,
	});

export const getPollingUnitById = (id: number) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + `PoolingUnit/${id}`,
			header: utils.header(),
		},
		actionType: locationType.pollingUnitById,
	});

export const getLGAsInState = (data: { stateIds: number[] }) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'LGA/getLgasInState',
			header: utils.header(),
			data: JSON.stringify(data),
		},
		actionType: locationType.lgasInState,
	});

export const getLGAsInConsistuency = (constituencyId: number) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + `ConstituencyLga/getLgasInConstituency?Constituencyid=${constituencyId}`,
			header: utils.header(),
		},
		actionType: locationType.lgasInConsistuency,
	});

export const getLGA = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				COREBASEURL +
				'lga/paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.lga,
	});

export const getStates = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'state',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.state,
	});

export const getPartyAction = () =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + 'party',
			header: utils.headerNoAuth(),
		},
		actionType: locationType.party,
	});

export const getConstituencyByIdAction = (id: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: COREBASEURL + `constituency/${id}`,
			header: utils.headerNoAuth(),
		},
		actionType: locationType.constituencyById,
	});
